import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Eta from "../../components/general/Eta";
import Banner from "../../components/general/Banner";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "reactstrap";
import { LuPhone } from "react-icons/lu";
import { MdOutlineLocalPrintshop, MdOutlineFileDownload } from "react-icons/md";
import { TiSocialLinkedin } from "react-icons/ti";
import { FiMapPin } from "react-icons/fi";
import { IoMailOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import kilavuz from "../../assets/images/eta_kurumsal_kilavuz.pdf";
import { useSelector, useDispatch } from "react-redux";
import { fetchContact } from "../../redux/slices/contactSlice";
import { fetchDocument } from "../../redux/slices/documentSlice";
import { fetchSeo } from "../../redux/slices/seoSlice";
import API from "../../api";

const Contact = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const { dataContact } = useSelector((state) => state.contact);
  const { dataContent } = useSelector((state) => state.content);
  const { dataDocument } = useSelector((state) => state.document);
  const { dataSeo } = useSelector((state) => state.seo);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    dispatch(fetchContact());
    dispatch(fetchDocument());
    dispatch(fetchSeo());
  }, [dispatch]);

  useEffect(() => {
    const setSeoContent = async () => {
      if (dataSeo?.length > 0) {
        const contactData = dataSeo.find(
          (item) =>
            item.title[lang] === "İletişim" || item.title[lang] === "Contact"
        );
        if (contactData) {
          setSeoData(contactData);
          document.title = contactData.title[lang];
        }
      }
    };

    setSeoContent();
  }, [dataSeo, lang]);

  let bannerText = "";
  let documentPath = "";
  let linkdln_text = "";
  if (dataContent) {
    bannerText = dataContent.showcaseText?.[lang] || "";
    linkdln_text = dataContent.specialField3?.[lang] || "";
  }
  if (dataDocument) {
    documentPath = dataDocument[0].files[0];
  }
  const contact = dataContact || {};

  const phone = contact.phone || "";
  const fax = contact.fax || "";
  const mail = contact.mail || "";
  const linkedin = contact.linkedin || "";
  let location = "";
  let coordinate = "";

  if (contact.location) {
    location = contact.location.location1 || "";
    coordinate = contact.location.location2 || "";
  }

  const company = contact.company?.[lang] || "";
  const companyDescription = contact.companyDescription?.[lang] || "";
  const specialField1 = contact.specialField1?.[lang] || "";

  return (
    <Eta>
      {seoData && (
        <Helmet>
          <title>{seoData.title[lang]}</title>
          <meta name="description" content={seoData.description[lang]} />
          {seoData.keywords[lang] && (
            <meta name="keywords" content={seoData.keywords[lang]} />
          )}
          {seoData.canonical && (
            <link rel="canonical" href={seoData.canonical} />
          )}
          {seoData.author && <meta name="author" content={seoData.author} />}
        </Helmet>
      )}
      <Banner title={bannerText} />
      <div className="contact-page">
        <Row>
          <Col xs={12} sm={12} md={6} lg={4} xl={4} className="mb-4 h-100">
            <Card className="item">
              <div className="icon">
                <LuPhone size={20} />
              </div>
              <div className="mt-2">
                <Link
                  to={`tel:${phone}`}
                  style={{ listStyle: "none", textDecorationLine: "none" }}
                  className="f16 fw500 color2"
                >
                  {phone}
                </Link>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={4} xl={4} className="mb-4 h-100">
            <Card className="item">
              <div className="icon">
                <MdOutlineLocalPrintshop size={20} />
              </div>
              <div className="mt-2">
                <Link
                  to={`tel:${fax}`}
                  style={{ listStyle: "none", textDecorationLine: "none" }}
                  className="f16 fw500 color2"
                >
                  {fax}
                </Link>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={4} xl={4} className="mb-4 h-100">
            <Card className="item">
              <div className="icon">
                <IoMailOutline size={20} />
              </div>
              <div className="mt-2">
                <Link
                  to={`mailto:${mail}`}
                  style={{ listStyle: "none", textDecorationLine: "none" }}
                  target="_blank"
                  className="f16 fw500 color2"
                >
                  {mail}
                </Link>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={4} xl={4} className="mb-4 h-100">
            <Card className="item">
              <div className="d-flex justify-content-between align-items-center">
                <Link target="_blank" to={linkedin}>
                  <div className="icon">
                    <TiSocialLinkedin size={20} />
                  </div>
                </Link>
                <div>
                  {/* <Button color='primary'><RxArrowTopRight size={20} />{t("go_page")}</Button> */}
                </div>
              </div>
              <div className="mt-2">
                <strong className="f20 fw500 color1">{linkdln_text}</strong>
              </div>
              <div className="mt-2">
                <span className="f16 fw400 color5">{specialField1}</span>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={12} lg={8} xl={8} className="mb-4 h-100">
            <Card className="item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <Link target="_blank" to={location}>
                    <div className="icon">
                      <FiMapPin size={20} />
                    </div>
                  </Link>
                </div>
              </div>
              {/* <Button color='primary'><RiRoadMapLine size={20} />{t("get_direction")}</Button> */}
              <div className="mt-2">
                <strong className="f20 fw500 color1">{company}</strong>
              </div>
              <div className="mt-2">
                <span className="f16 fw400 color5">{companyDescription}</span>
              </div>
            </Card>
          </Col>
        </Row>
        <div className="mt-4">
          <iframe
            title={company}
            src={coordinate}
            // src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3061.016484984342!2d32.7718302!3d39.8962632!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d3463a83f73e2f%3A0x452a7304d86ed545!2sEta%20Elektronik!5e0!3m2!1sen!2str!4v1742305034844!5m2!1sen!2str"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <div className="kilavuz">
        <Link
          to={`${API.BASE}${documentPath}`}
          // to={kilavuz}
          target="_blank"
          className="text-decoration-none color5 f16 fw500"
        >
          <MdOutlineFileDownload size={24} className="" /> Logo Kullanım
          Kılavuzu
        </Link>
      </div>
    </Eta>
  );
};

export default Contact;
